import { State } from '../../../reducers';
import { createSelector } from '@ngrx/store';
import * as fromIncident from './incident.reducer';


export const incidentState = (state: State) => state.incidents;

export const selectAllIncidents = createSelector(incidentState, (state: fromIncident.State) => state.incidents);
export const selectAllIncidentAttributes = createSelector(incidentState, (state: fromIncident.State) => state.incidentAttributes);
